import NaptimeResource from './NaptimeResource';

type PriceVariant = {
  variantName: string;
};

export type DiscretionaryDiscount = {
  id: string;
  purchaserUserId?: number;
  orgId?: string;
  priceVariant?: PriceVariant;
  createdAt?: number;
  expiresAt?: number;
  appliedAt?: number;
  licenseCount?: number;
};

class EnterpriseDiscretionaryDiscounts extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseDiscretionaryDiscounts.v1';

  id!: string;

  purchaserUserId?: number;

  orgId?: string;

  priceVariant?: PriceVariant;

  createdAt?: number;

  expiresAt?: number;

  appliedAt?: number;

  licenseCount?: number;
}

export default EnterpriseDiscretionaryDiscounts;
